import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { notifyError, notifySuccess } from '../../Utils/CustomNotifcations'
import { compose } from 'redux'
import TextField from './../common/TextField'
import { withStyles } from '@mui/styles'
import Checkbox from './../common/Checkbox'
import Grid from '@mui/material/Grid'
import Button from '../common/Button'
import isEqual from 'react-fast-compare'
import { ServerInfo } from '../../Actions/serverSetting'
import { checkPrivileges } from '../../Helpers'
import Loader from './../../Layout/Loader'
import withTranslationWrapper from '../../HOC/HocTranslate'
import { apiFetch } from '../../Utils/apiFetch'
import { Alert } from '@mui/material'
import SmsIcon from '@mui/icons-material/Sms'

// Moved to top level so it's available to all methods before use
const userAttributesTypes = [
  {
    key: 'sms.http.url',
    name: 'attributeSmsHttpUrl',
    valueType: 'string',
    htmlTag: 'input'
  },
  {
    key: 'sms.http.authorizationHeader',
    name: 'attributeSmsHttpAuthorizationHeader',
    valueType: 'string',
    htmlTag: 'input'
  },
  {
    key: 'sms.http.authorization',
    name: 'attributeSmsHttpAuthorization',
    valueType: 'text',
    htmlTag: 'input'
  },
  {
    key: 'sms.http.user',
    name: 'attributeSmsHttpUser',
    valueType: 'text',
    htmlTag: 'input'
  },
  {
    key: 'sms.http.password',
    name: 'attributeSmsHttpPassword',
    valueType: 'text',
    htmlTag: 'input'
  },
  {
    key: 'sms.http.template',
    name: 'attributeSmsHttpTemplate',
    valueType: 'text',
    htmlTag: 'input'
  },
  {
    key: 'sms.http.enable',
    name: 'attributeSmsHttpEnable',
    valueType: 'boolean',
    htmlTag: 'input'
  }
]

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  button: {
    margin: theme.spacing(1)
  }
})

class SmsGatway extends Component {
  constructor (props) {
    // Fix 1: Always pass props to super() in constructors
    super(props)
    this.state = {
      selectedType: '',
      selectTagData: '',
      htmlTag: '',
      isVisableAddBtn: false,
      form: {},
      loading: false,
      isTested: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.formSubmit = this.formSubmit.bind(this)
    this.formReset = this.formReset.bind(this)
  }

  // Fix 2: componentWillMount is deprecated — replaced with componentDidMount
  componentDidMount () {
    if (this.props.ServerSetting) {
      this.setState({
        form: { ...this.props.ServerSetting.attributes }
      })
    }
  }

  formReset () {
    // Fix 3: Simplified — just restore form from ServerSetting attributes directly,
    // filtering only keys that exist in userAttributesTypes
    const allAttributes = this.props.ServerSetting?.attributes || {}
    const knownKeys = userAttributesTypes.map(f => f.key)

    const restoredForm = Object.keys(allAttributes).reduce((acc, key) => {
      if (knownKeys.includes(key)) {
        acc[key] = allAttributes[key]
      }
      return acc
    }, {})

    this.setState({
      form: restoredForm,
      isVisableAddBtn: false
    })
  }

  formSubmit () {
    if (!this.props.ServerSetting?.attributes) return

    const allAttributes = this.props.ServerSetting.attributes
    const knownKeys = userAttributesTypes.map(f => f.key)

    // Preserve attributes not managed by this form
    const otherAttributes = Object.keys(allAttributes).reduce((acc, key) => {
      if (!knownKeys.includes(key)) {
        acc[key] = allAttributes[key]
      }
      return acc
    }, {})

    // Fix 4: Avoid mutating props — build a new ServerSetting object
    const updatedServerSetting = {
      ...this.props.ServerSetting,
      attributes: {
        ...otherAttributes,
        ...this.state.form
      }
    }

    apiFetch(`/api/accounts/${updatedServerSetting.id}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...updatedServerSetting })
    })
      .then(response => {
        if (response.ok) {
          response.json().then(server => {
            if (server.status === 'success') {
              if (this.props.updateOtherServerSetting) {
                this.props.updateSelectedAccount(updatedServerSetting)
              } else {
                this.props.dispatch(ServerInfo(updatedServerSetting))
              }
              this.props.dispatch(notifySuccess('defaultInfoIsUpdated'))
            } else if (server?.statusCode === '440') {
              window.location.replace('/login')
            } else if (server.statusCode) {
              const err = server?.message.split(':')
              err[1] = err[1].replace(')', '')
              this.props.dispatch(notifyError(err[1]))
            }
          })
          this.setState({ isVisableAddBtn: false })
        } else {
          throw response
        }
      })
      .catch(e => {
        console.error('SmsGatway formSubmit error:', e)
        this.props.dispatch(notifyError('somthingWentWrongMessage'))
      })
  }

  handleChange (key, event) {
    if (!event?.target) return

    const { target } = event
    this.setState({ isTested: true })

    let value = target.type === 'checkbox' ? target.checked : target.value

    if (value === false) value = ''

    if (target.type === 'number') {
      value = parseInt(value)
      if (value === 0 || isNaN(value)) value = ''
    }

    if (value === '') {
      // Fix 5: Avoid direct state mutation — use a copy before deleting the key
      const updatedForm = { ...this.state.form }
      delete updatedForm[key]
      this.setState({ form: updatedForm }, () => this.checkRequiredFields())
    } else {
      this.setState(
        { form: { ...this.state.form, [key]: value } },
        () => this.checkRequiredFields()
      )
    }
  }

  checkRequiredFields = () => {
    const changed = !isEqual(
      this.state.form,
      this.props?.ServerSetting?.attributes
    )
    this.setState({
      isVisableAddBtn: this.state.isTested && changed
    })
  }

  render () {
    const { form, loading } = this.state
    const isReadOnly = this.props.logInUser.userType !== -1

    const renderFields = () => {
      const fieldArray = []

      // Fix 6: Use forEach instead of misusing .map() with no return value used
      userAttributesTypes.forEach(field => {
        if (field.htmlTag !== 'input') return

        const gridSize = this.props.updateOtherServerSetting ? 4 : 3

        if (field.valueType === 'boolean') {
          fieldArray.push(
            <Grid item md={gridSize} key={field.key}>
              <Checkbox
                label={this.props.translate(field.name)}
                checked={form[field.key] || false}
                onChange={this.handleChange.bind(this, field.key)}
                color='primary'
                InputProps={{ readOnly: isReadOnly }}
              />
            </Grid>
          )
        } else {
          // Covers 'text', 'string', and 'number' valueTypes
          fieldArray.push(
            <Grid item md={gridSize} key={field.key}>
              <TextField
                id={field.key}
                label={this.props.translate(field.name)}
                type={field.valueType === 'number' ? 'number' : 'text'}
                placeholder=''
                value={form[field.key] || ''}
                onChange={this.handleChange.bind(this, field.key)}
                variant='outlined'
                margin='dense'
                fullWidth
                InputProps={{ readOnly: isReadOnly }}
              />
            </Grid>
          )
        }
      })

      return <Grid container spacing={2}>{fieldArray}</Grid>
    }

    if (loading) {
      return <Loader defaultStyle />
    }

    return (
      <div>
        <Alert
          severity='info'
          icon={<SmsIcon />}
          sx={{ mb: 3, borderRadius: 2 }}
        >
          <strong>SMS HTTP Settings</strong>
          <br />
          Configure your SMS gateway URL, authentication, and message template.
        </Alert>

        {renderFields()}
        <br />

        {checkPrivileges('userUpdate') &&
          this.props.logInUser.userType === -1 && (
            <Fragment>
              <Button
                variant='contained'
                onClick={this.formReset}
                style={{ marginLeft: 8, marginRight: 8 }}
              >
                {this.props.translate('resetButton')}
              </Button>
              <Button
                variant='contained'
                disabled={!this.state.isVisableAddBtn}
                onClick={this.formSubmit}
              >
                {this.props.translate('sharedSave')}
              </Button>
            </Fragment>
          )}
      </div>
    )
  }
}

const enhance = compose(withStyles(styles), connect())
export default withTranslationWrapper(enhance(SmsGatway))